import { Link, useLocation } from 'react-router-dom'

const TABS = [
  { label: 'Property Mapping', path: '/pms-automation/property-mapping' },
  { label: 'Resident Mapping', path: '/yardi-matching' },
] as const

export function PmsAutomationTabs() {
  const { pathname } = useLocation()

  return (
    <div className="flex flex-wrap gap-6 border-b border-slate-200" aria-label="Yardi automation sections">
      {TABS.map((tab) => {
        const active =
          tab.path === '/yardi-matching'
            ? pathname === tab.path || pathname.startsWith(`${tab.path}/`)
            : pathname === tab.path

        return (
          <Link
            key={tab.path}
            to={tab.path}
            className={`whitespace-nowrap border-b-2 px-1 pb-3 text-sm font-semibold transition ${
              active
                ? 'border-sky-500 text-sky-700'
                : 'border-transparent text-slate-500 hover:text-slate-800'
            }`}
          >
            {tab.label}
          </Link>
        )
      })}
    </div>
  )
}
